﻿<template>
  <span />
</template>

<script lang="ts">
import Utility from '../../../common/UtilityFunctions'
import { defineComponent, PropType } from 'vue';
import { SalesForceChatInfo } from './types/SalesForceChat';

export default defineComponent({
  name: 'SalesforceChatTracking',
  props: {
    salesForceChatInfo: {
      type: Object as PropType<SalesForceChatInfo>,
      default() {
        return null;
      }
    },
    baseFeatureScriptUrl: String,
    customFeatureScriptUrl: String
  },
  mounted() {
    const salesForceChatInfoScript = document.createElement('script');
    salesForceChatInfoScript.setAttribute(
      "type",
      "text/javascript"
    );

    if (this.salesForceChatInfo) {
        const innerHtmlString = `var salesForceChatInfo = { memberId: '${this.salesForceChatInfo.memberId}', memberFirstName: '${this.salesForceChatInfo.memberFirstName}', powerOfAttorneyId: '${this.salesForceChatInfo.powerOfAttorneyId}', environmentUrl: '${this.salesForceChatInfo.environmentUrl}'}`;
        salesForceChatInfoScript.innerHTML = innerHtmlString;
        document.head.appendChild(salesForceChatInfoScript);
    }
    
    if (this.baseFeatureScriptUrl){
      const baseScript = document.createElement("script");
      baseScript.setAttribute(
        "type",
        "text/javascript"
      );
      baseScript.setAttribute(
        "src",
        this.baseFeatureScriptUrl
      );
      document.head.appendChild(baseScript);
    }

    if (this.customFeatureScriptUrl){
      const customScript = document.createElement("script");
      customScript.setAttribute(
        "type",
        "text/javascript"
      );
      customScript.setAttribute(
        "src",
        this.customFeatureScriptUrl
      );
      document.head.appendChild(customScript);
    }

    const chatButton = document.querySelector('button.uiButton.helpButtonEnabled');
    if (chatButton !== null) {
      chatButton.addEventListener('click', this.pushToTagManager, false);
    }
  },
  methods: {
    pushToTagManager() {
      Utility.pushToTagManager({
        event: 'track-event',
        eventCategory: 'chat',
        eventAction: 'open',
        eventLabel: 'chat',
        eventValue: '0',
        eventNoninteraction: true
      });
    }
  }
});
</script>
